import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Checkbox } from "@/components/ui/checkbox";

const ITEMS = {
  micro: [
    ["auth", "J'ai obtenu l'autorisation du professeur et des personnes qui seront enregistrées."],
    ["rules", "Je respecte le règlement de mon établissement et je n'enregistre personne à son insu."],
    ["private", "Je comprends que l'enregistrement est visible pendant toute sa durée, qu'il reste privé et ne sera jamais publié."],
  ],
  import: [
    ["auth", "Ce fichier a été enregistré avec l'autorisation des personnes qu'on y entend."],
    ["private", "Je comprends que l'audio sera transcrit puis supprimé, et que mes notes restent privées."],
  ],
};

export const ConsentDialog = ({ open, onOpenChange, onConfirm, mode = "micro" }) => {
  const [checked, setChecked] = useState({});
  const items = ITEMS[mode];
  const ok = items.every(([k]) => checked[k]);
  return (
    <Dialog open={open} onOpenChange={(v) => { onOpenChange(v); if (!v) setChecked({}); }}>
      <DialogContent className="rounded-3xl sm:max-w-lg" data-testid="recording-consent-dialog">
        <DialogHeader>
          <span className="mb-2 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-accent text-accent-foreground"><ShieldCheck className="h-5 w-5" /></span>
          <DialogTitle className="text-xl">As-tu l'autorisation d'enregistrer ?</DialogTitle>
          <DialogDescription>Enregistrer quelqu'un sans son accord est interdit. Merci de confirmer chaque point.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2.5">
          {items.map(([k, label]) => (
            <label key={k} className="flex cursor-pointer gap-3 rounded-2xl border p-3.5 text-sm transition-colors hover:border-primary/40">
              <Checkbox data-testid={`consent-check-${k}`} checked={!!checked[k]} onCheckedChange={(v) => setChecked((c) => ({ ...c, [k]: !!v }))} className="mt-0.5" />
              <span>{label}</span>
            </label>
          ))}
        </div>
        <div className="mt-2 flex justify-end gap-2">
          <button data-testid="consent-cancel-button" onClick={() => onOpenChange(false)} className="rounded-full px-5 py-2.5 text-sm font-semibold hover:bg-muted">Annuler</button>
          <button data-testid="consent-confirm-button" disabled={!ok} onClick={() => { setChecked({}); onConfirm(); }}
            className="bg-brand rounded-full px-5 py-2.5 text-sm font-semibold text-white transition-opacity disabled:opacity-50">
            Je confirme
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
